import React from 'react';
import { motion } from 'framer-motion';
import { Gamepad2 } from 'lucide-react';

const PageLoader = () => {
  return (
    <motion.div
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-[#050811]"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.4, ease: "easeInOut" }}
    >
      <motion.div
        className="relative text-center"
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.8, opacity: 0 }}
        transition={{ duration: 0.5, ease: "easeOut" }}
      >
        <div className="w-24 h-24 rounded-3xl overflow-hidden shadow-2xl border border-white/20 mx-auto bg-white/5 p-2 flex items-center justify-center">
          <img src="/favicon.ico" alt="AvalonMC Logo" className="w-full h-full object-contain" />
        </div>

        <div className="flex gap-3 mt-8 justify-center">
          {[0, 1, 2].map((i) => (
            <motion.div
              key={i}
              className="w-3.5 h-3.5 bg-emerald-400 rounded-full"
              animate={{
                y: [0, -12, 0],
              }}
              transition={{
                duration: 0.6,
                repeat: Infinity,
                delay: i * 0.15,
                ease: "easeInOut",
              }}
            />
          ))}
        </div>

        <motion.p
          className="text-white text-lg font-bold mt-6 tracking-wider"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3 }}
        >
          آوالون ام‌سی
        </motion.p>
      </motion.div>
    </motion.div>
  );
};

export default PageLoader;